'use strict';
var React = require('react');
var Components = require('./Components.jsx');

var FullPage = React.createClass({
  propTypes: {
    page: React.PropTypes.object.isRequired,
    pageDidLoad: React.PropTypes.func.isRequired,
    fullPageLocation: React.PropTypes.object.isRequired,
  },
  componentDidMount: function () {
    var offset = $('.full-page').offset();
    this.props.pageDidLoad(offset);
  },
  shouldComponentUpdate: function (nextProps, nextState) {
    var oldLocation = nextProps.fullPageLocation;
    var newLocation = $('.full-page').offset();
    //终止update死循环
    if (oldLocation.left === newLocation.left
      && oldLocation.top === newLocation.top) {
      return false;
    }
    return true;
  },
  componentDidUpdate: function () {
    var offset = $('.full-page').offset();
    this.props.pageDidLoad(offset);
  },

  render: function () {
    var page = this.props.page;
    var backgroundColor = page.param[0].backgroundColor;
    var components = page.controls.control || [];
    return (
      <div className="full-page" style={{
        width: page.measureW,
        height: page.measureH,
        background: backgroundColor
      }}>
        <Components components={components}/>
      </div>
    );
  }
});

module.exports = FullPage;



// WEBPACK FOOTER //
// ./src/views/Page/FullPage.jsx